import { Component, OnInit, Injector, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganizationSubUsersService } from 'app/core/http/services/organizationSubUsers.service';
import { DialogData } from 'app/core/interfaces/dialog';
import { OrganizationUser, Permissions } from 'app/core/interfaces/organizationUser';
import { BaseComponent } from 'app/modules/shared/components/base.component';

@Component({
  selector: 'page-users-details',
  templateUrl: './users-details.component.html',
  styleUrls: ['./users-details.component.scss'],
})
export class OrganizationUserDetailsComponent extends BaseComponent implements OnInit {
  public successUpdate: boolean = false;
  public submitted: boolean = false;
  public organizationUser!: OrganizationUser;
  public title = "Dados do usuário";

  public allPermissions: Permissions[] = [
    'DASHBOARD:manage',
    'SCHEDULE:manage',
    'PRACTITIONERS:manage',
    'HEALTHCARES:manage',
    'PAYMENT_CONFIG:manage',
    'AGREEMENTS:manage',
  ];

  public userPermissions: Permissions[] = [];

  private permissionLabels: { [key: string]: string } = {
    DASHBOARD: 'Dashboard',
    SCHEDULE: 'Agenda',
    PRACTITIONERS: 'Especialistas',
    HEALTHCARES: 'Exames',
    PAYMENT_CONFIG: 'Configurações de Pagamento',
    AGREEMENTS: 'Convênios',
  };

  constructor(
    private injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private organizationSubUsersService: OrganizationSubUsersService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.organizationUser = this.data.param.user;
    this.syncPermissions();
  }

  getPermissionLabel(menuName: string): string {
    return this.permissionLabels[menuName] || menuName;
  }

  public syncPermissions(): void {
    if (this.organizationUser?.permissions?.length) {
      this.userPermissions = [...this.organizationUser.permissions.filter((perm) => perm.endsWith(':manage'))];
    }
  }

  togglePermission(menu: string, isChecked: boolean): void {
    const permissionString: Permissions = `${menu}:manage`;

    if (isChecked) {
      if (!this.userPermissions.includes(permissionString)) {
        this.userPermissions.push(permissionString);
      }
    } else {
      this.userPermissions = this.userPermissions.filter((perm) => perm !== permissionString);
    }
  }

  savePermissions() {
    const updatedUser: OrganizationUser = {
      ...this.organizationUser,
      permissions: [...this.userPermissions],
    };

    this.organizationSubUsersService.updateSubUser(this.organizationUser.organization_sub_user_id!, updatedUser).subscribe({
      next: (organizationSubUsers: any) => {
        this.submitted = true;
        this.successUpdate = true;
      },
      error: (err) => {
        this.submitted = true;
        this.successUpdate = false;
        console.error('Erro ao atualizar permissões:', err);
      },
    });
  }

  disableAccess() {
    this.layout
      .openDialog({
        showButtonCancel: true,
        buttonText: 'salvar',
        title: '',
        content: 'Deseja remover o acesso do usuário?',
      })
      .subscribe((retorno: any) => {
        if (retorno) {
          this.removeAccess();
        }
      });
  }

  removeAccess() {
    this.organizationSubUsersService.deleteSubUser(this.organizationUser.organization_sub_user_id!).subscribe({
      next: (organizationSubUser: any) => {
        console.log('Acesso desabilitado com sucesso', organizationSubUser);
        this.submitted = true;
        this.successUpdate = true;
      },
      error: (err) => {
        this.submitted = true;
        this.successUpdate = false;
        console.error('Erro ao remover acesso:', err);
      },
    });
  }

  activeAccess() {
    this.layout
      .openDialog({
        showButtonCancel: true,
        buttonText: 'salvar',
        title: '',
        content: 'Deseja habilitar o acesso do usuário?',
      })
      .subscribe((retorno: any) => {
        if (retorno) {
          this.activeSubUser();
        }
      });
  }

  activeSubUser() {
    const updatedUser: OrganizationUser = {
      ...this.organizationUser,
      active: true,
    };

    this.organizationSubUsersService.updateSubUser(this.organizationUser.organization_sub_user_id!, updatedUser).subscribe({
      next: (organizationSubUser: any) => {
        this.submitted = true;
        this.successUpdate = true;
        console.log('Acesso habilitado com sucesso', organizationSubUser);
      },
      error: (err) => {
        this.submitted = true;
        this.successUpdate = false;
        console.error('Erro ao habilitar acesso:', err);
      },
    });
  }

  changeAvatarDialog() {
    //@TODO METHOD TO CHANGE USER AVATAR
  }
}
